import React from 'react';
import { useStaticQuery, graphql, Link } from 'gatsby'
import * as classes from './index.module.css'
import Arrow from '@Svg/arrow-bold.svg'
import Logo from '@Svg/logo.svg'
import RichText from '@components/RichText'
import PropTypes from 'prop-types';
import SubscribeForm from './Subscribe';

const Footer = ({location}) => {

    const { contentfulGlobalConfigurations: {
                siteEmail,
                sitePhone,
                siteAddress,
                location: siteLocation,
                newsletterMessage,
                socialLinks
            }} = useStaticQuery(
                graphql`
                    query {
                        contentfulGlobalConfigurations {
                            siteEmail
                            sitePhone
                            siteAddress
                            location
                            newsletterMessage {
                                raw
                            }
                            socialLinks {
                                title
                                url
                            }
                        }
                    }
                `
            )
    
    return (
        <>
            <footer className={classes.root}>
                <div className={classes.cont}>
                    <div className={classes.logoContainer}>
                        <Logo className={classes.logo} />
                    </div>
                    <div className={classes.row}>
                        <div className={classes.col}>
                            <ul>
                                <li className={classes.servicesListItem}>
                                    <Link to={`/services`} className={classes.serviceLink}>
                                        <span className={classes.linkDefault}>Services <Arrow className={classes.arrow}/></span>
                                        <span className={classes.linkHover} >Services <Arrow className={classes.arrow}/></span>
                                    </Link>
                                </li>
                                <li className={classes.servicesListItem}>
                                    <Link to={`/culture`} className={classes.serviceLink}>
                                        <span className={classes.linkDefault}>Culture <Arrow className={classes.arrow}/></span>
                                        <span className={classes.linkHover} >Culture <Arrow className={classes.arrow}/></span>
                                    </Link>
                                </li>
                            </ul>
                            <RichText content={newsletterMessage} className={classes.newsletterMessage}/>
                            <SubscribeForm />
                        </div>
                        <div className={classes.colSecond}>
                            <ul className={classes.siteContact}>
                                <li><a href={`mailto:${siteEmail}`} aria-label="Our email" className={classes.contactLink}>{siteEmail}</a></li>
                                <li><a href={`tel:${sitePhone}`} aria-label="Our phone" className={classes.contactLink}>{sitePhone}</a></li>
                                <li><a href={`${siteLocation}`} target="_blank" aria-label="Our location" rel="noreferrer" className={classes.contactLink}>{siteAddress}</a></li>
                            </ul>
                            <ul className={classes.socialLinks}>
                                {socialLinks.map((item, index) => (
                                    <li key={index}><a href={`${item.url}`} className={classes.contactLink} target="_blank" rel="noreferrer">{item.title}</a></li>
                                ))}
                            </ul>
                        </div>
                    </div>
                    <div className={classes.footerBottom}>
                        <span className={classes.copyrights}>©2025 Jungle</span>
                        <ul className={classes.bottomLinks}>
                            <li>
                                <Link to={`/cookie-policy`}  className={classes.bottomLink}>Cookies</Link>
                            </li>
                            <li>
                                <Link to={`/privacy-policy`}  className={classes.bottomLink}>Privacy</Link>
                            </li>
                        </ul>
                    </div>
                </div>
            </footer>
        </>
    );
};

Footer.propTypes = {
    location: PropTypes.object
};

export default Footer;